interface ExportHeaderProps {
  teamName: string
  sessionType?: string
  sessionDate?: string
  sessionName?: string
  playerName?: string
  playerNumber?: number | null
  title?: string
  partitionName?: string
}

export function ExportHeader({
  teamName,
  sessionType,
  sessionDate,
  sessionName,
  playerName,
  playerNumber,
  title,
  partitionName
}: ExportHeaderProps) {
  const subtitleParts = [sessionType, sessionName, partitionName].filter(
    Boolean
  )

  return (
    <div className='hidden print:mb-4 print:block' style={{ color: '#000' }}>
      <h1 className='font-normal'>{teamName}</h1>
      {title && <h1 className='font-normal'>{title}</h1>}
      {subtitleParts.length > 0 && (
        <h3 className='font-normal'>{subtitleParts.join(' - ')}</h3>
      )}
      {sessionDate && <p className='mt-1 text-sm'>{sessionDate}</p>}
      {playerName && (
        <p className='mt-1 text-sm text-gray-600'>
          {playerNumber != null && `#${playerNumber} `}
          {playerName}
        </p>
      )}
    </div>
  )
}
